module.exports = __webpack_public_path__ + "img/ChartLineUp.5be33238.svg";